"use client";

import React from "react";
import { CircleCheck, Users, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reasons = [{
  title: "Quality & Compliance",
  description: "Licensed and insured, we adhere to the highest industry standards for safety and reliability.",
  icon: Award
}, {
  title: "Collaborative Approach",
  description: "Our experienced team works closely with clients to ensure projects are delivered on time.",
  icon: Users
}, {
  title: "Proven Reliability",
  description: "Specialists in commercial fitouts and remedial works with a focus on asset performance.",
  icon: CircleCheck
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="243362" id="foundationofexcellence" className="bg-background text-foreground py-20 md:py-32 overflow-hidden border-y border-border/50">
      <div ref={ref} className={`container mx-auto px-6 max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-6xl font-bold text-secondary mb-6 tracking-tighter uppercase">
            THE FOUNDATION OF EXCELLENCE
          </h2>
          <p className="font-default text-lg md:text-xl text-muted-foreground font-medium leading-relaxed">
            Bottom Up Projects delivers high-quality commercial and industrial solutions. 
            We combine industry-leading project management with transparent communication 
            to ensure efficient and accountable project outcomes for every client.
          </p>
        </div>

        {}
        <div className="text-center">
          <h3 className="font-mono text-sm md:text-base font-semibold text-primary mb-12 tracking-widest uppercase">
            BUILDING TOGETHER....
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                  <div className="w-16 h-16 rounded-none bg-primary/5 border border-primary/20 flex items-center justify-center mb-6 transition-all duration-300 group-hover:bg-primary group-hover:border-primary">
                    <Icon className="w-8 h-8 text-primary group-hover:text-primary-foreground" strokeWidth={1.5} />
                  </div>
                  <h4 className="font-default text-xl font-bold text-secondary mb-3 uppercase tracking-tight">
                    {reason.title}
                  </h4>
                  <p className="font-default text-muted-foreground leading-relaxed">
                    {reason.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}